import React from "react"
import { connect } from "react-redux"

import map from "../../images/world_map.png"

import collaboration from "../../images/icon/icon-collaboration.svg"
import retail from "../../images/icon/icon-retail.svg"
import design from "../../images/icon/icon-design.svg"
import branding from "../../images/icon/icon-branding.svg"
import editorial from "../../images/icon/icon-editorial.svg"
import mpl from "../../images/icon/icon-mpl.svg"
import storytelling from "../../images/icon/icon-storytelling.svg"

const HiddenClocks = ({ mobile, show, times }) => {
  function _getDegree(type, hour, minute) {
    if (type === "hour") {
      hour = hour > 12 ? hour - 12 : hour
      hour = hour - 3
      return 30 * hour + 0.5 * minute
    } else if (type === "minute") {
      minute = minute - 15
      return 6 * minute
    }
  }

  return (
    <div id="hiddenNavBar" className={`${show ? "show" : ""}`}>
      <div id="hiddenClocks" className={`${show ? "show" : ""}`}>
        <div id="clock-container" style={{ background: `url(${map})` }}>
          {times.map((i, idx) => {
            let hour = i.time.split(":")[0]
            let minute = i.time.split(":")[1]
            let hour_style = {
              transform: `rotate(${_getDegree("hour", hour, minute)}deg)`,
            }
            let minute_style = {
              transform: `rotate(${_getDegree("minute", hour, minute)}deg)`,
            }
            return (
              <div key={idx} className="city-container">
                <div className="clock">
                  <div className="dot" />
                  <div style={hour_style} className="dial hour" />
                  <div style={minute_style} className="dial minute" />
                </div>
                <div className="city-name">{i.city}</div>
              </div>
            )
          })}
        </div>
      </div>
      <div id="stock-container" className="">
        <marquee behavior="" direction="">
          <p>
            {[...Array(50).keys()].map((i, idx) => {
              return (
                <span key={idx}>
                  <span>branding</span>
                  <img className="banner-icon branding" src={branding} alt="" />
                  <span>design & development</span>
                  <img className="banner-icon design" src={design} alt="" />
                  <span>collaboration curation</span>
                  <img
                    className="banner-icon collaboration"
                    src={collaboration}
                    alt=""
                  />
                  <span>storytelling</span>
                  <img
                    className="banner-icon storytelling"
                    src={storytelling}
                    alt=""
                  />
                  <span>retail strategy</span>
                  <img className="banner-icon retail" src={retail} alt="" />
                  <span>editorial</span>
                  <img
                    className="banner-icon editorial"
                    src={editorial}
                    alt=""
                  />
                  <span>mpl</span>
                  <img
                    className="banner-icon mpl"
                    src={mpl}
                    alt=""
                  />
                </span>
              )
            })}
          </p>
        </marquee>
      </div>
    </div>
  )
}

export default connect(
  state => ({
    mobile: state.global.mobile,
    times: state.navbar.times,
    show: state.navbar.showClocks,
  }),
  null
)(HiddenClocks)
